import { cognito } from 'Config';

const { origin } = window.location;

const awsconfig = {
  aws_project_region: cognito.REGION,
  aws_cognito_identity_pool_id: cognito.IDENTITY_POOL_ID,
  aws_cognito_region: cognito.REGION,
  aws_user_pools_id: cognito.USER_POOL_ID,
  aws_user_pools_web_client_id: cognito.APP_CLIENT_ID,
  oauth: {
    domain: cognito.DOMAIN_AUTH,
    scope: ['email', 'openid'],
    redirectSignIn: `${origin}/login`,
    redirectSignOut: `${origin}/login`,
    clientId: cognito.APP_CLIENT_ID,
    responseType: 'code',
  },
};

export default awsconfig;
